import axios from 'axios/dist/axios';


const defaultState = {
    vitalParameters: null,
    vitalParametersGroups: {},
    mustShowVitalParamsForm: false,
    focusVitalParameter: null
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    vitalParameters: defaultState.vitalParameters,
    vitalParametersGroups: defaultState.vitalParametersGroups,
    mustShowVitalParamsForm: defaultState.mustShowVitalParamsForm,
    focusVitalParameter: defaultState.focusVitalParameter
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getVitalParameters: state => state.vitalParameters,

    getVitalParametersGroups(state) {
        return state.vitalParametersGroups;
    },

    getMustShowVitalParamsForm: state => state.mustShowVitalParamsForm,

    /*getIsVitalParamsFormValid(state) {

        if (state.vitalParameters === null || state.vitalParameters.vitalParameters === null || state.vitalParameters.vitalParameters.length === 0) {
            return true;
        }
        if (state.vitalParameters.generalValidationError !== null) {
            return false;
        }

        const vitalParamsWithError = state.vitalParameters.vitalParameters.filter((vitalParam) => {
            return (vitalParam.validationError !== null) ? true : false;
        });

        return (vitalParamsWithError.length === 0) ? true : false;
    },*/

    getInvalidVitalParams(state) {

        if (state.vitalParameters === null || state.vitalParameters.vitalParameters === null || state.vitalParameters.vitalParameters.length === 0) {
            return [];
        }

        const vitalParamsWithError = state.vitalParameters.vitalParameters.filter((vitalParam) => {
            return (vitalParam.validationError !== null) ? true : false;
        });

        return vitalParamsWithError;
    },

    getMustFocusVitalParameter(state) {
        return state.focusVitalParameter !== null;
    },

    getFocusVitalParameter(state) {
        return state.focusVitalParameter;
    }

};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    setupVitalParameters({commit}, vitalParams) {
        commit("setVitalParameters", vitalParams);
        commit("setupVitalParametersGroups");
    },

    submitVitalParameterValue ({commit, dispatch}, payload) {

        const {vitalParam, currentRoute} = payload;

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideVitalParameter', {
                paramName: vitalParam.name,
                paramValue: vitalParam.value
            });
            axiosRequest.then((response) => {

                if (currentRoute.name === 'AssessmentStartPage' || currentRoute.name === 'AssessmentStartListPage'){
                    // Refresh page data.
                    dispatch("AssessmentStartStore/updateAssessmentStartQuestionsData", response.data, {root: true});
                }
                else if (currentRoute.name === 'ChooseMainSymptomPage'){
                    // Refresh Vital Parameters data.
                    dispatch('setupVitalParameters', response.data.data.VITAL_PARAMETERS);
                }
                else if (currentRoute.name === 'SymptomsQuestionsPage' || currentRoute.name === 'AssessmentSymptomsPriorityListPage'){
                    // When changing a VitalParam refresh the SymptomsQuestions data.
                    dispatch('SymptomsQuestionsStore/updateSymptomQuestionData', response.data, {root: true});
                    // Refresh Vital Parameters data.
                    dispatch('setupVitalParameters', response.data.data.VITAL_PARAMETERS);
                }

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, {root: true});
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

};



// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setVitalParameters(state, vitalParams) {

        if (typeof vitalParams.vitalParameters !== 'undefined' && vitalParams.vitalParameters !== null && vitalParams.vitalParameters.length > 0) {
            vitalParams.vitalParameters = vitalParams.vitalParameters.map((vitalParamObj) => {
                if (state.mustShowVitalParamsForm === false && state.focusVitalParameter === null && vitalParamObj.validationError != null) {
                    state.focusVitalParameter = vitalParamObj;
                    setTimeout(() => {
                        state.mustShowVitalParamsForm = true;
                    }, 100)
                }
                const extendedVitalParam = {...vitalParamObj, initialValue: {...vitalParamObj}.value}; // const extendedVitalParam = {...vitalParamObj, initialValue: JSON.parse(JSON.stringify(vitalParamObj)).value};
                return extendedVitalParam;
            });
        }

        state.vitalParameters = vitalParams;
    },

    setMustShowVitalParamsForm(state, newValue) {
        state.mustShowVitalParamsForm = newValue;
    },


    setupVitalParametersGroups(state) {

        if (state.vitalParameters === null || state.vitalParameters.vitalParameters === null || state.vitalParameters.vitalParameters.length === 0) {
            return;
        }

        const vitalParamsGroups = {};

        state.vitalParameters.vitalParameters.forEach((vitalParamObj) => {
            const groupName = vitalParamObj.group;
            if (groupName === null) {
                return;
            }

            vitalParamObj.label = this._vm.$text('api.pro.vital.parameters.label.measure.unity.' + vitalParamObj.name);

            if (typeof vitalParamsGroups[groupName] === "undefined") {
                // No group with current name has been created yet.
                // We define the group now and mark this first vital parameter as selected one.
                // The first vital parameters in group is selected by default, but in some cases the selection is overwritten later (see the code after this forEach loop).
                vitalParamsGroups[groupName] = {
                    groupName: groupName,
                    value: vitalParamObj.value,
                    selectedVitalParamName: (vitalParamObj.groupSelected === true) ? true : false,
                    vitalParameters: [vitalParamObj],
                    validationError: vitalParamObj.validationError
                };
            }
            else {
                vitalParamsGroups[groupName].vitalParameters.push(vitalParamObj);
            }

        });


        Object.keys(vitalParamsGroups).forEach((vitalParamGroupName) => {
            const selectedVitalParam = vitalParamsGroups[vitalParamGroupName].vitalParameters.find((vitalParamObj) => {
                return (vitalParamObj.groupSelected === true) ? true : false;
            });

            if (typeof selectedVitalParam !== "undefined") {
                vitalParamsGroups[vitalParamGroupName].value = selectedVitalParam.value;
                vitalParamsGroups[vitalParamGroupName].selectedVitalParamName = selectedVitalParam.name;
                vitalParamsGroups[vitalParamGroupName].validationError = selectedVitalParam.validationError;
            }
            else {
                // In current group, no vital parameter is marked as selected, so just select the first vital parameter in group.
                vitalParamsGroups[vitalParamGroupName].value = vitalParamsGroups[vitalParamGroupName].vitalParameters[0].value;
                vitalParamsGroups[vitalParamGroupName].selectedVitalParamName = vitalParamsGroups[vitalParamGroupName].vitalParameters[0].name;
                vitalParamsGroups[vitalParamGroupName].validationError = vitalParamsGroups[vitalParamGroupName].vitalParameters[0].validationError;
            }

            vitalParamsGroups[vitalParamGroupName] = {
                ...vitalParamsGroups[vitalParamGroupName],
                initialValue: {...vitalParamsGroups[vitalParamGroupName]}.value,
                initialSelectedVitalParamName: {...vitalParamsGroups[vitalParamGroupName]}.selectedVitalParamName
            };
        });

        state.vitalParametersGroups = vitalParamsGroups;
    },

    setSelectedVitalParamInGroup(state, payload) {
        const {groupName, newSelectedVitalParamName} = payload;
        state.vitalParametersGroups[groupName].selectedVitalParamName = newSelectedVitalParamName;
    },

    setFocusVitalParameter(state, payload) {
        state.focusVitalParameter = payload;
    },



    // ----------------------------------------------------------

    resetStore (state) {
        state.vitalParameters = defaultState.vitalParameters;
        state.vitalParametersGroups = defaultState.vitalParametersGroups;
        state.mustShowVitalParamsForm = defaultState.mustShowVitalParamsForm;
    }

};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/VitalParametersStore.js